import React, {createContext, useContext, useEffect, useState} from 'react';
import {jwtDecode} from "jwt-decode";

// Create the context
const UserContext = createContext();

// Create a custom hook to use the context
export const useUserContext = () => {
    return useContext(UserContext);
};

// Create a provider component
export const UserProvider = ({children}) => {

    const [userDetails, setUserDetails] = useState()

    useEffect(() => {
        const userToken = localStorage.getItem('token');
        if (userToken) {
            const decodedJwt = jwtDecode(userToken);
            setUserDetails(decodedJwt)
            console.log('decoded > decodedJwt', decodedJwt)
        }
    }, [])
    

    const userTokenExtract = (userToken) => {

        if (userToken) {
            const decodedJwt = jwtDecode(userToken);
            setUserDetails(decodedJwt)
            console.log('decoded > decodedJwt', decodedJwt)
        }

    }

    return (
        <UserContext.Provider value={{userDetails, userTokenExtract}}>
            {children}
        </UserContext.Provider>
    );
};